import type {ListCustomerOffersSearchInput} from "./list-customer-offers.schema";
import {useQuery} from "@tanstack/react-query";
import {listCustomerOffersQueryOptions} from "./list-customer-offers.query-options";

export function useListCustomerOffers(rawInput: ListCustomerOffersSearchInput) {
  return useQuery(listCustomerOffersQueryOptions(rawInput));
}
